(function () {
    'use strict';

    angular
        .module('actionPlanModule')
        .controller('grcActionPlanListController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        $scope.actionPlans = $scope.boxModel;    
        $scope.recommendation = $scope.boxContext.Recommendation;
        $scope.ctxActionPlanList = {};

        // Is Recommendation owner
        $scope.isRecommendationOwner = function () {
            if (_.isUndefined($scope.authenticatedUser)) return false;
            if (_.isUndefined($scope.recommendation.OwnerID)) return false;

            return $scope.authenticatedUser.ItemPersonID === $scope.recommendation.OwnerID;
        };
    }
})();